import React from "react"
import Footer from "../components/Footer/Footer"
import Navbar from "../components/Navbar/Navbar"
import Seo from "../components/Seo"

export default function PrivacyPolicy() {
  return (
    <React.Fragment>
      <Seo title={"Privacy Policy"} />
      <Navbar />
      <main className="marginTopNavbar">
        <div className="main-container">
          <section className="overview">
            <div className="grid-8-col">
              <div className="col-3">
                <h1 className="sticky">Privacy Policy</h1>
              </div>

              <div className="col-4" style={{ minWidth: 0 }}>

                <p>
                  The concept of protection of individuals, generally translated as privacy,
                  but referring to the processing of personal data, in the complex spirit of
                  the European legislator, as a fundamental right enshrined in the Charter of
                  Fundamental Rights of the EU and in the Treaty on the Functioning of the EU,
                  can be reduced to the right of individuals to control their private lives and
                  personal information, while data protection would be the technical and
                  organisational measures that guarantee that privacy. It is from this
                  perspective that this privacy policy has been drafted, as a set of commitments
                  aimed at the protection of individuals.
                </p>
                <br />
                <br />

                <h2>Legal Disclaimer</h2>
                <br />
                <p>
                  Before accessing these websites, the Advanced Therapies Group recommends
                  reading this legal notice and taking note of the provisions applicable to
                  each of the documents, information, data and requirements contained therein.
                </p>
                <br />
                <p>
                  The contents of these websites are the responsibility and legitimate property
                  of the Advanced Therapies Group and are copyrighted. They are intended to
                  provide information on the activities arising from the provisions of its
                  statutes and may not be reproduced or altered for commercial or other purposes
                  without prior authorisation, except in cases where their use is for
                  educational/didactic or journalistic purposes. In such cases, reference should
                  be made to the source.
                </p>
                <br />
                <p>
                  The Advanced Therapies Group takes the utmost care in the production,
                  compilation and distribution of information, but cannot guarantee that it is
                  updated in real time. Therefore, any suggestions or requests for clarification
                  should be sent to{" "}
                  <a href="mailto:lino.ferreira@uc.pt">lino.ferreira@uc.pt</a>. Similarly,
                  although the Advanced Therapies Group seeks to minimise the inconvenience
                  caused by technical errors, it cannot guarantee that such errors will not
                  occur and therefore declines any responsibility for any negative impacts that
                  may arise as a result of consulting the contents of these websites or other
                  external websites linked to them.
                </p>
                <br />
                <p>
                  This disclaimer is not intended to limit liability in a manner that would
                  contravene applicable law, nor does it seek to exclude liability in cases
                  where this is not legally permitted. The Advanced Therapies Group reserves
                  the right to change the terms announced herein without prior notice,
                  undertaking in such cases to disclose the new conditions.
                </p>
                <br />
                <br />

                <h2>The Protection of Data Subjects through 'Data Protection'</h2>
                <br />
                <p>
                  The Advanced Therapies Group is committed to the six principles underlying
                  the General Data Protection Regulation (GDPR), the Portuguese Data
                  Protection Law and all other relevant standards relating to the protection
                  of individuals' rights and freedoms. Personal data shall be:
                </p>
                <br />
                <ul style={{ paddingLeft: "1.5rem" }}>
                  <li style={{ marginBottom: "0.75rem" }}>
                    processed lawfully, fairly and in a transparent manner in relation to the
                    data subject (<em>'lawfulness, fairness and transparency'</em>);
                  </li>
                  <li style={{ marginBottom: "0.75rem" }}>
                    collected for specified, explicit and legitimate purposes and not further
                    processed in a manner that is incompatible with those purposes; further
                    processing for archiving purposes in the public interest, scientific or
                    historical research purposes or statistical purposes shall, in accordance
                    with Article 89(1), not be considered to be incompatible with the initial
                    purposes (<em>'purpose limitation'</em>);
                  </li>
                  <li style={{ marginBottom: "0.75rem" }}>
                    adequate, relevant and limited to what is necessary in relation to the
                    purposes for which they are processed (<em>'data minimisation'</em>);
                  </li>
                  <li style={{ marginBottom: "0.75rem" }}>
                    accurate and, where necessary, kept up to date (<em>'accuracy'</em>);
                  </li>
                  <li style={{ marginBottom: "0.75rem" }}>
                    kept in a form which permits identification of data subjects for no longer
                    than is necessary for the purposes for which the personal data are processed
                    (<em>'storage limitation'</em>);
                  </li>
                  <li style={{ marginBottom: "0.75rem" }}>
                    processed in a manner that ensures appropriate security of the personal
                    data, including protection against unauthorised or unlawful processing and
                    against accidental loss, destruction or damage, using appropriate technical
                    or organisational measures (<em>'integrity and confidentiality'</em>).
                  </li>
                </ul>
                <br />
                <p>
                  The Advanced Therapies Group treats personal data for the purposes of
                  management, administration, research, or other purposes required by law, as
                  well as for the execution of statutory and regulatory requirements.
                </p>
                <br />
                <p>
                  All processing of personal data complies with this Policy, with the guidance
                  of the national supervisory authority — the Comissão Nacional de Proteção de
                  Dados (National Data Protection Commission / CNPD).
                </p>
                <br />
                <br />

                <h2>[0] – Our Commitment</h2>
                <br />
                <ul style={{ paddingLeft: "1.5rem" }}>
                  <li style={{ marginBottom: "0.5rem" }}>Protect the security and privacy of personal data;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Communicate transparently about the personal data we manage and under what conditions;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Provide appropriate mechanisms for the exercise of the rights of data subjects;</li>
                  <li style={{ marginBottom: "0.5rem" }}>
                    Respect the provisions of (EU) Regulation 2016/679 of the European
                    Parliament and of the 27th April 2016 Council — GDPR — and other
                    applicable legislation, including national legislation supplementing the GDPR.
                  </li>
                </ul>
                <br />
                <br />

                <h2>[1] – Terms of Use</h2>
                <br />
                <p>
                  All contents of this website, unless otherwise indicated, are owned by the
                  Advanced Therapies Group and may not be reproduced or modified without its
                  express permission, except in cases of free use, namely for teaching or
                  research purposes or for personal use. In these cases their ownership shall
                  be mentioned.
                </p>
                <br />
                <p>
                  The guidelines, recommendations and information contained on our website aim
                  at a better understanding of data protection rules and may not under any
                  circumstances be used to create legal rights or expectations. Since these
                  guidelines reflect the state of the art at the time of their preparation,
                  they should be considered as an "evolutionary instrument" open to improvement
                  and contents' updating.
                </p>
                <br />
                <p>
                  The access to this website implies full acceptance of the various notices
                  contained therein, and that you agree to use the website lawfully and in no
                  way cause any harm to the rights or interests of the Advanced Therapies Group
                  or any third party.
                </p>
                <br />
                <br />

                <h2>[2] – Reservation of Right of Disposal</h2>
                <br />
                <p>
                  The Advanced Therapies Group reserves the right at any time to update this
                  document and to provide additional, more detailed information about specific
                  situations in which personal data are collected and processed. These
                  additional privacy notices are complementary to this primary Privacy Policy
                  and should be regularly consulted by the data subjects, without prejudice to
                  the commitment that any changes that may affect the data subjects' rights or
                  interests will be disclosed to those concerned.
                </p>
                <br />
                <br />

                <h2>[3] – Responsible for the Processing of Personal Data</h2>
                <br />
                <p>
                  For the purposes of GDPR Articles 4 and 24, the data controller is the
                  Advanced Therapies Group, since it is the entity that decides which data are
                  collected, the material and human means used in the treatment, the storage
                  period and their purpose.
                </p>
                <br />
                <br />

                <h2>[4] – Collection of Personal Data (Object)</h2>
                <br />
                <p>
                  Data may be provided directly by the data subject, may be collected within
                  the relationship established with the data subject and may also be requested
                  and processed with the data subject's consent. The Advanced Therapies Group
                  collects personal data in person, by telephone, in writing or through
                  computer systems, including, in particular, when users visit our website,
                  subscribe to newsletters, respond to surveys, fill out forms or other
                  features or resources available on the website. All data collected through
                  forms contain their protection clauses, which comply with the provisions of
                  the data protection regulations, and in all cases only personal data deemed
                  appropriate, relevant and not excessive are treated, in order to comply with
                  the specific, explicit and legitimate purposes for which they are intended.
                </p>
                <br />
                <br />

                <h2>[5] – Collection of Personal Data (Types)</h2>
                <br />
                <p>
                  The following categories of personal data may be collected and processed:
                </p>
                <br />
                <ul style={{ paddingLeft: "1.5rem" }}>
                  <li style={{ marginBottom: "0.5rem" }}>Identification data, including image for the protection of people and assets;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Family life data, social or financial circumstance;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Education, training and employment data;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Attendance and disciplinary data.</li>
                </ul>
                <br />
                <p>
                  The processing of special category data is performed in limited
                  circumstances, always in accordance with the law, and with the prior and
                  explicit consent of their holders. This data may be:
                </p>
                <br />
                <ul style={{ paddingLeft: "1.5rem" }}>
                  <li style={{ marginBottom: "0.5rem" }}>Racial or ethnic;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Political opinions or trade union membership;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Religious or philosophical beliefs;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Sexual life or orientation;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Health, genetic or biometric data for the purpose of person identification.</li>
                </ul>
                <br />
                <br />

                <h2>[6] – Processing of Personal Data (Object)</h2>
                <br />
                <p>
                  The processing of personal data includes, but is not limited to, the
                  collection, registration, consult, use, adaptation, alteration, storage and
                  destruction of data.
                </p>
                <br />
                <br />

                <h2>[7] – Data Processing (Information to be Provided to the Holder)</h2>
                <br />
                <p>
                  The information about the processing of personal data is provided to the
                  data subject at the time of data collection or, if the personal data was
                  obtained from another source, within a reasonable period of time, depending
                  on the circumstances.
                </p>
                <br />
                <p>
                  Given the diversity of situations that entail the collection and processing
                  of personal data, at the time of collection, the Advanced Therapies Group
                  provides the holder of the personal data detailed information on the use that
                  will be made of the information, namely:
                </p>
                <br />
                <ul style={{ paddingLeft: "1.5rem" }}>
                  <li style={{ marginBottom: "0.5rem" }}>The purpose(s) for which personal data are intended, as well as the legal basis for their processing;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Unambiguous identification of the data controller and processor, if applicable;</li>
                  <li style={{ marginBottom: "0.5rem" }}>The recipient(s) or categories of recipients of personal data (if applicable);</li>
                  <li style={{ marginBottom: "0.5rem" }}>The entities to whom the data may be communicated;</li>
                  <li style={{ marginBottom: "0.5rem" }}>The possibility of transferring data to third countries (outside the EEA);</li>
                  <li style={{ marginBottom: "0.5rem" }}>The data retention period or the criteria used to define this period;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Identification of the data subject's rights;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Automated individual decision-making, including profiling;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Any additional information relevant for fair and transparent processing.</li>
                </ul>
                <br />
                <br />

                <h2>[8] – Processing of Personal Data (Lawfulness)</h2>
                <br />
                <p>
                  The processing is lawful if at least one of the following situations (GDPR
                  paragraph 1, article 6) occurs:
                </p>
                <br />
                <ul style={{ paddingLeft: "1.5rem" }}>
                  <li style={{ marginBottom: "0.75rem" }}>
                    <strong>Consent</strong> — the data subject has given prior consent; in
                    certain cases, data will only be processed if the data subject consents,
                    for example, to the processing of "special categories" of data or personal
                    data of minors;
                  </li>
                  <li style={{ marginBottom: "0.75rem" }}>
                    <strong>Contract</strong> — necessary for the performance of a contract to
                    which the data subject is a party;
                  </li>
                  <li style={{ marginBottom: "0.75rem" }}>
                    <strong>Legal obligation</strong> — necessary for compliance with a legal
                    obligation to which the controller is subject;
                  </li>
                  <li style={{ marginBottom: "0.75rem" }}>
                    <strong>Vital interests</strong> — necessary in order to protect the vital
                    interests of the data subject or of another person;
                  </li>
                  <li style={{ marginBottom: "0.75rem" }}>
                    <strong>Public interest</strong> — necessary for the performance of a task
                    carried out in the public interest or in the exercise of official authority.
                  </li>
                </ul>
                <br />
                <br />

                <h2>[9] – Processing of Personal Data (Purposes)</h2>
                <br />
                <p>Data processing is aimed at:</p>
                <br />
                <ul style={{ paddingLeft: "1.5rem" }}>
                  <li style={{ marginBottom: "0.5rem" }}>Emergency situations;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Research, investigation and archive;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Granting direct and indirect social support;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Promotion and dissemination of the Advanced Therapies Group activities;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Official and regulatory reports, as well as accounting/financial reports;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Administrative purposes, including academic, financial and human resource management, as well as administration of access to facilities or services and attendance;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Higher Education Statistics Agencies and other entities with legal authority to process data relating to higher education matters, in Portugal or in the European Economic Area.</li>
                </ul>
                <br />
                <br />

                <h2>[10] – Security Measures</h2>
                <br />
                <p>
                  As responsible for the processing of personal data and information, the
                  Advanced Therapies Group ensures that it implements and promotes appropriate
                  and effective technical and organizational measures to comply with data
                  protection principles, with the aim of ensuring permanent confidentiality,
                  integrity, availability and resilience of their processing systems and
                  services.
                </p>
                <br />
                <p>
                  The Advanced Therapies Group ensures administrative, technical and
                  organizational measures against possible misuse or unauthorized access.
                  However, it is the responsibility of the users/holders to ensure and
                  guarantee that their computers are adequately protected against harmful
                  software, computer viruses and worms.
                </p>
                <br />
                <br />

                <h2>[11] – Limitation of Liability</h2>
                <br />
                <p>
                  The Advanced Therapies Group reserves the right to adjust its website terms
                  of use at any time and is not liable for any damages resulting from access to
                  the website, even if they result from access to outdated contents or from
                  virus contact by accessing different networks.
                </p>
                <br />
                <br />

                <h2>[12] – Cookies</h2>
                <br />
                <p>
                  This website may use cookies so as to improve the service quality, the
                  available functionalities and the user experience, without the use of any
                  technology or automated decisions leading to profiling. Disallowing the use
                  of cookies in some of our website's features may affect its performance and
                  user experience.
                </p>
                <br />
                <p>
                  Cookies are small files with alphanumeric information that identify the
                  computers (not users) on our servers, and therefore no personal information
                  of our users is recorded, nor any information that allows their
                  identification. For more information, please consult our{" "}
                  <a href="/cookie-policy">Cookie Policy</a>.
                </p>
                <br />
                <br />

                <h2>[13] – Retention Period of Personal Data</h2>
                <br />
                <p>
                  The retention period of personal data is that set by law or guidelines or,
                  in its absence, it shall be the necessary period for the pursuit of the
                  purpose that motivated its collection and processing, after which the
                  personal data are deleted.
                </p>
                <br />
                <p>
                  However, for the purpose of data processing for public interest archives,
                  for scientific or historical research purposes or for statistical purposes,
                  some data may be retained for longer periods, without prejudice to the
                  application of the appropriate protection of the rights and data subject's
                  freedoms, in accordance with the applicable law.
                </p>
                <br />
                <br />

                <h2>[14] – Data Subjects' Rights of Access, Alteration and Erasure</h2>
                <br />
                <p>
                  Upon verification of the legally provided conditions, the Advanced Therapies
                  Group guarantees to data subjects the right to access, update, rectify,
                  delete, limit or opposition to the processing of personal data concerning
                  them.
                </p>
                <br />
                <p>
                  The right of access can be exercised through in-person contact or by e-mail
                  at{" "}
                  <a href="mailto:edp@uc.pt">edp@uc.pt</a>.
                </p>
                <br />
                <br />

                <h2>[15] – Subcontractors and Transfer of Data to Third Parties</h2>
                <br />
                <p>
                  The Advanced Therapies Group, within its competence, may use subcontractors
                  to provide services. When data processing is performed by a subcontractor or
                  third party to whom data are transmitted, the Advanced Therapies Group shall
                  verify if they provide guarantees on appropriate technical and organizational
                  measures, so that the processing complies with the GDPR requirements and
                  safeguards the data subject's rights.
                </p>
                <br />
                <p>
                  The Advanced Therapies Group is bound to law and administrative procedures
                  and is therefore obliged to provide information to other entities, namely:
                </p>
                <br />
                <ul style={{ paddingLeft: "1.5rem" }}>
                  <li style={{ marginBottom: "0.5rem" }}>Embassies;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Professional entities;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Research institutions;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Insurance companies;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Other public institutions;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Higher Education Accreditation Entities;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Partner universities for Erasmus programme or equivalent;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Financing Agencies / Partner Institutions submitting applications for national or community funding.</li>
                </ul>
                <br />
                <p>
                  When sharing personal information with one of these entities, the Advanced
                  Therapies Group will take all necessary measures and/or actions to confirm
                  that they will perform their duties in accordance with GDPR principles.
                </p>
                <br />
                <br />

                <h2>[16] – Data Protection Officer (DPO)</h2>
                <br />
                <p>
                  Pursuant to GDPR article 37, a Data Protection Officer (DPO) has been
                  nominated who can be contacted by e-mail at{" "}
                  <a href="mailto:edp@uc.pt">edp@uc.pt</a>.
                </p>
                <br />
                <p>Among other functions, the DPO is responsible for:</p>
                <br />
                <ul style={{ paddingLeft: "1.5rem" }}>
                  <li style={{ marginBottom: "0.5rem" }}>Monitoring the compliance of data processing according to the applicable standards;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Being a point of contact for the clarification of issues related to data processing;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Cooperating with the CNPD as supervisory authority;</li>
                  <li style={{ marginBottom: "0.5rem" }}>Providing information and advising on privacy and data protection obligations.</li>
                </ul>
                <br />
                <br />

                <h2>[17] – Supervisory Authority</h2>
                <br />
                <p>
                  The data subject has the right to lodge a complaint with the supervisory
                  authority.
                </p>
                <br />
                <p>
                  <strong>Comissão Nacional de Proteção de Dados (CNPD)</strong>
                  <br />
                  Rua de São Bento n.º 148-3.º
                  <br />
                  1200-821 Lisboa
                </p>
                <br />
                <br />

                <h2>Data Subjects under 18 Years Old</h2>
                <br />
                <p>
                  The processing of personal data of minors depends on the consent of their
                  parents or legal representatives and preferably also on their own consent.
                  However, if the minor has already reached the age of 13 and if the
                  processing of their data takes place exclusively in the context of information
                  society services, their consent is sufficient. Please note that in these cases
                  minors can, for example, give their consent to receive information about a
                  product or services, but cannot enter into contracts or commitments involving
                  payments without the consent of their parents or legal representatives.
                </p>
                <br />
                <br />

                <p style={{ fontSize: "0.875rem", color: "#666" }}>
                  Last revised: 18/06/2026
                </p>
                <br />
                <br />
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  )
}
